import { render, staticRenderFns } from "./ExpansionPanelPolygon.vue?vue&type=template&id=5a71e860&scoped=true"
import script from "./ExpansionPanelPolygon.vue?vue&type=script&lang=js"
export * from "./ExpansionPanelPolygon.vue?vue&type=script&lang=js"
import style0 from "./ExpansionPanelPolygon.vue?vue&type=style&index=0&id=5a71e860&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a71e860",
  null
  
)

export default component.exports